module.exports = __webpack_public_path__ + "img/9.460c0dc6.png";